import MyTrips from "./MyTrips";

export default MyTrips;